import React, { useState, useEffect } from 'react';
import { Header, Footer } from '../../Container';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import '../../../assets/css/Cogen.css';
import prof from '../../../assets/images/prof.svg';
import downloadIcon from '../../../assets/images/download.svg';
import { useLocation } from 'react-router-dom';
import NewApplicants from './JobApplicants/NewApplicants';
import ShortlistApplicants from './JobApplicants/ShortlistApplicants';
import { ReqGet, ReqPost } from '../../../config/Requests';
// import { useToasts } from 'react-toast-notifications';
import jsPDF from 'jspdf';
import { generatePDF } from './JobApplicants/ViewProfile';
import { Multiselect } from 'multiselect-react-dropdown';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

function ApplyClientNotify() {
	const navigate = useNavigate();
	const location = useLocation();
	const [job, setJob] = useState([]);
	const [shortlistapplicants, setShortlistApplicants] = useState([]);
	const [applicantList, setApplicantList] = useState([]);
	var { id, memberId } = useParams();

	// const profile = useSelector(state => state.auth.profile.user);
	const profile = useSelector(state => state.auth.profile);

	useEffect(() => {
		setRequest({ isInitiated: true });
		ReqGet(`job/${id}/applicants`)
			.then(res => {
				setApplicantList(res.data);
				setRequest({
					isInitiated: false,
					isSuccess: true,
					shortlistApplicantsInitiated: false,
				});
			})
			.catch(err => {
				setRequest({ isSuccess: false, isFailed: true });
			});

		setRequest({ shortlistApplicantsInitiated: true });
		ReqGet(`shortlist/job/${id}`)
			.then(res => {
				setShortlistApplicants(res.data);
				setRequest({
					shortlistApplicantsInitiated: false,
					shortlistApplicantsSuccess: true,
					isSuccess: true,
				});
			})
			.catch(err => {
				setRequest({
					shortlistApplicantsSuccess: false,
					shortlistApplicantsFailed: true,
				});
			});

		setRequest({ JobInitiated: true });
		ReqGet(`jobs/${id}`)
			.then(({ data }) => {
				setJob(data.data);
				setRequest({
					JobInitiated: false,
					shortlistApplicantsSuccess: true,
					isSuccess: true,
				});
			})
			.catch(err => {
				setRequest({
					shortlistApplicantsSuccess: false,
					shortlistApplicantsFailed: true,
				});
			});
	}, []);

	const [request, setRequest] = useState({
		isInitiated: false,
		isSuccess: false,
		isFailed: false,
		shortlistApplicantsInitiated: false,
		shortlistApplicantsSuccess: false,
		shortlistApplicantsFailed: false,
	});

	const { member, title } = location.state.params;
	const shortlistHandler = (memberId, jobId) => {
		ReqPost(`shortlist/job/${jobId}`, { members: memberId })
			.then(res => {
				setRequest({ shortlistApplicantsInitiated: true });
				toast.success(res.data.message);

				ReqGet(`shortlist/job/${id}`)
					.then(res => {
						setShortlistApplicants(res.data);
						console.log(res.data);
						setRequest({
							shortlistApplicantsInitiated: false,
							shortlistpplicantsSuccess: true,
							isSuccess: true,
						});
					})
					.catch(err => {
						console.log(err.response);
						setRequest({ shortlistpplicantsSuccess: false, isFailed: true });
					});
			})
			.catch(err => {
				toast.error(err?.response?.data?.message);

				console.log(err.message);
			});
	};

	const declineApplicantHandler = (memberId, jobId) => {
		ReqPost(`decline-member/job/${jobId}`, { members: memberId })
			.then(res => {
				toast.success(res.data.message);

				setRequest({ shortlistApplicantsInitiated: true });
				ReqGet(`job/${id}/applicants`)
					.then(res => {
						setApplicantList(res.data);
						setRequest({
							shortlistApplicantsInitiated: false,
							shortlistpplicantsSuccess: true,
							isSuccess: true,
						});
					})
					.catch(err => {
						console.log(err.response);
						setRequest({ shortlistpplicantsSuccess: false, isFailed: true });
					});
			})
			.catch(err => {
				toast.error(err?.response?.data?.message);
				console.log(err.message);
			});
	};

	return (
		<Container fluid='true'>
			<Header type='member' />

			<Container className='flex-column mt-5 notification align-content-inherit'>
				<Col md='auto'>
					<div className='row'>
						<div className='col-8'>
							<Button
								className='btn_cancel'
								variant='primary'
								onClick={() => navigate('/notifications/0')}
							>
								Back{' '}
							</Button>
						</div>
						{job.published ? (
							<div className='col-4 text-right'>
								<Button
									variant='success'
									onClick={() => navigate(`/job/${id}/applicants`)}
								>
									Job Details
								</Button>
							</div>
						) : (
							''
						)}
					</div>
				</Col>
				{/* <div className="wrapper pb-2 pt-2">
          <h5 className="title">{title}: {member.fullname}</h5>
        </div>
        <div className="wrapper">
          <br />
          <h6 >Applicant Details</h6>
          <Row className="row">
          {member.profile_image?<img className="profile" style={{ padding: '2px', span: 2, offset: 1 }} src={member.profile_image} alt="profile" />:<img className="profile-img" src={prof} alt="profile" />}
            <Col>
              <h6>{member.fullname}</h6>
              <p className="designation">Engineer</p>
              <p className="email">{member.email}</p>
              <p className="phone-number">{member.phone}</p>
            </Col>
          </Row>
          <br />
        </div> */}
				<div className=' pb-4 pt-4'>
					{/* <h6 className="mb-2">Resume</h6> */}
					<a
						className='resume mb-2'
						href={member.resume_link}
						onClick={() => generatePDF(member.id, member.first_name)}
						target='_blank'
						rel='noopener noreferrer'
					>
						{member.fullname} Resume doc{' '}
						<img className='download-icon' src={downloadIcon} alt='profile' />
					</a>

					<div id='element-to-print'>
						<Row className='mt-5'>
							<Col md='auto'>
								<img
									className='profile'
									style={{ padding: '2px' }}
									src={member.profile_image ? member?.profile_image : prof}
									alt='profile'
								/>
							</Col>
							<Col md='auto' className='pl-3 pt-2'>
								{member.professional_title !== null && (
									<span className='text-primary'>
										{' '}
										{member.professional_title.name}{' '}
									</span>
								)}

								<span>
									<strong>
										{member?.first_name} {member?.last_name}{' '}
									</strong>{' '}
								</span>
								{/* <p className="designation">Engineer</p> */}
								<p className='email'>{member?.email}</p>
								<p className='phone-number'>{member?.phone}</p>
							</Col>
						</Row>
						<Row className='bg-label mt-4'>
							<Col className='fw-bold p-1 ml-3'> Applicant Info </Col>
						</Row>
						<Row>
							<Col>
								<ul className='list-group list-group-flush'>
									<li className='list-group-item font-weight-normal'>
										Member ID: <span className='text-primary'>{member.id}</span>
									</li>
								</ul>
							</Col>
						</Row>

						{/* <Row className="bg-label mt-1">
              <Col className="fw-bold p-1 ml-3"> Availability </Col>
            </Row>
            <Row>
              <Col>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item font-weight-normal">Current Status: <span className="text-primary">Available</span></li> */}
						{/* <li className="list-group-item font-weight-normal">From: {profile.available_start} To: {profile.available_end}</li>
                            <li className="list-group-item font-weight-normal"></li> */}
						{/* </ul>
              </Col>
            </Row> */}
						<Row className='bg-label mt-1'>
							<Col className='fw-bold p-1 ml-3'> Tags </Col>
						</Row>
						<Row>
							<Col>
								<ul className='list-group list-group-flush list-multi-select'>
									<Multiselect
										options={member.tags}
										placeholder=''
										// isObject={false}
										displayValue='display_name'
										selectedValues={member.tags}
										disable='true'
										// style={{ chips: { background: "blue" }, searchBox: { border: "hidden", background: "white" } }}
										style={{
											chips: {
												background: 'blue',
												fontWeight: '600',
												fontSize: '14px',
											},
											searchBox: { border: 'hidden', background: 'white' },
										}}
									/>
								</ul>
							</Col>
						</Row>
						<Row className='bg-label mt-1'>
							<Col className='fw-bold p-1 ml-3'>
								{' '}
								Member Information{' '}
							</Col>
						</Row>
						<Row>
							<Col>
								<ul className='list-group list-group-flush'>
									<li className='list-group-item font-weight-normal'>
										{' '}
										<span className='fw-bold'>Email: </span>{' '}
										{member.email}
									</li>
									<li className='list-group-item font-weight-normal'>
										{' '}
										<span className='fw-bold'>Email-2: </span>{' '}
										{member.email2}
									</li>
									<li className='list-group-item font-weight-normal'>
										{' '}
										<span className='fw-bold'>Phone: </span>
										{member.phone}
									</li>
									<li className='list-group-item font-weight-normal'>
										{' '}
										<span className='fw-bold'>Phone-2: </span>
										{member.phone2}
									</li>
									<li className='list-group-item font-weight-normal'>
										{' '}
										<span className='fw-bold'>Address: </span>{' '}
										{member.address}
									</li>
									<li className='list-group-item font-weight-normal'>
										{' '}
										<span className='fw-bold'>Job Location: </span>
										{member.job_location == 'remote' && 'Remote'}{' '}
										{member.job_location == 'both' && 'Both'}{' '}
										{member.job_location == 'onsite' && 'On-site'}
									</li>
									<li className='list-group-item font-weight-normal'>
										{' '}
										<span className='fw-bold'>
											Job Preference:{' '}
										</span>{' '}
										{member.job_preference}
									</li>
									<li className='list-group-item font-weight-normal'>
										{' '}
										<span className='fw-bold'>Job Type: </span>
										{member.job_type == 'fullTime' && 'Full Time'}{' '}
										{member.job_type == 'halfTime' && 'Half Time'}{' '}
										{member.job_type == 'both' && 'Full & half time'}
									</li>
									<li className='list-group-item font-weight-normal'>
										{' '}
										<span className='fw-bold'>Travel Type: </span>
										{member.travel_type == 'InState' && 'In state'}{' '}
										{member.travel_type == 'Domestic' && 'Domestic'}{' '}
										{member.travel_type == 'International' && 'International'}
									</li>
									<li className='list-group-item font-weight-normal'>
										{' '}
										<span className='fw-bold'>
											Social Media Link:{' '}
										</span>
										{member.linkedin_link}
									</li>
									<li className='list-group-item font-weight-normal'>
										{' '}
										<span className='fw-bold'>Worker Type: </span>
										{member?.worker_type == '1099-subcontractor' &&
											'1099 Subcontractor'}
										{member?.worker_type == 'w2-contingent-worker' &&
											'W2 Contingent Worker'}
										{member?.worker_type ==
											'contingent-to-full-time-employee' &&
											'Contingent to Full Time Employee'}
										{member?.worker_type == 'part-time-contingent' &&
											'Part Time Contingent'}
									</li>

									<li className='list-group-item font-weight-normal'>
										{' '}
										<span className='fw-bold'>Requirement: </span>
										{member?.other_requirements?.map((requirement, index) => {
											return (
												<span key={index}>
													{' '}
													{requirement}
													{member?.other_requirements?.length != index + 1 && (
														<span>,</span>
													)}{' '}
												</span>
											);
										})}
									</li>
									<li className='list-group-item font-weight-normal'>
										{' '}
										<span className='fw-bold'>Expertise: </span>
										{member?.specific_expertise?.map((expertise, index) => {
											return (
												<span key={index}>
													{' '}
													{expertise}
													{member?.specific_expertise?.length != index + 1 && (
														<span>,</span>
													)}{' '}
												</span>
											);
										})}
									</li>
									<li className='list-group-item font-weight-normal'>
										{' '}
										<span className='fw-bold'>Tools: </span>
										{member?.tool?.map((tool, index) => {
											return (
												<span key={index}>
													{' '}
													{tool}
													{member?.tool?.length != index + 1 && (
														<span>,</span>
													)}{' '}
												</span>
											);
										})}
									</li>
								</ul>
							</Col>
						</Row>
						<Row>
							<Col>
								<ul className='list-group list-group-flush'>
									<li className='list-group-item font-weight-normal'>
										{member.official_doc}{' '}
									</li>
									<li className='list-group-item font-weight-normal'></li>
								</ul>
							</Col>
						</Row>
					</div>
				</div>
				<div style={{ display: 'none' }}>
					<div className='wrapper pt-4 pb-4'>
						<h6>Cover Letter</h6>
						<p className='cover-letter'>
							Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
							eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
							enim ad minim veniam, quis nostrud exercitation ullamco laboris
							nisi ut aliquip ex ea commodo consequat.
							<br />
							Duis aute irure dolor in reprehenderit in voluptate velit esse
							cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
							cupidatat non proident, sunt in culpa qui officia deserunt mollit
							anim id est laborum.
						</p>
					</div>
				</div>
				<div className='button-wrapper mt-4 mb-5'>
					<button
						className='btn-accept-applicant'
						onClick={() => shortlistHandler(memberId, id)}
					>
						Accept applicant for short-list
					</button>
					<button
						className='btn-decline-applicant'
						onClick={() => declineApplicantHandler(memberId, id)}
					>
						Decline
					</button>
				</div>
			</Container>
			<Footer />
		</Container>
	);
}

export default ApplyClientNotify;
